import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { CurrencyPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ColDef, ExcelStyle, GridApi, GridReadyEvent } from 'ag-grid-community';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { ValueBtnComponent } from './value-btn.component';
import { RouterHandlerService } from 'src/app/services/router-handler.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { NewFilterService } from 'src/app/services/new-filter.service';
import { PatientValueGetterComponent } from '../../shared/patient-value-getter/patient-value-getter.component';
import { GridStateService } from 'src/app/services/grid-state.service';
import { CryptoService } from 'src/app/services/crypto.service';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { PreferencesComponent } from '../../shared/preferences/preferences.component';

@Component({
    selector: 'app-basic-grid-list',
    templateUrl: './basic-grid-list.component.html',
    styleUrls: ['./basic-grid-list.component.scss'],
    standalone: false
})
export class BasicGridListComponent implements OnInit {
  static key = 100811;

  cardName: any;
  clientKey: any;
  moduleKey: any;
  moduleName:any;
  dashboardKey: any;
  decryptedParams:any;
  cardId: any;
  patientId: any;
  @Input("item") item: any = {};
  @Input("pageKey") pageKey: any;
  @ViewChild("fs") fs!: ElementRef;
  @ViewChild("gridList") gridList!: ElementRef;
  @ViewChild("dataEditGridDiv", { static: true }) dataEditGridDiv!: ElementRef;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @HostBinding("class.is-fullscreen") isFullscreen = false;
  @Input() hdr: any;
  defaultColumnDefs: ColDef[] = [];
  isActive = false;
  reqSubcription: Subscription[] = [];
  rowData:any[]=[];
  DynamicColumn:any
  loader = true;
  moment = moment;
  filterValue: any;
  widgetUniqKey:any;
  paginationPageSize:any = 10;
  paginationFlag = false;
  selectedSearchByKey:any;
  serverSideSearchFilterText:any;
  filterSearchParams:any;
  private gridApi!: GridApi;
  public columnDefs:any;
  public columnConfig: ColDef[] = [];
  public detailRowHeight = 50;
  public themeClass: string = "ag-theme-quartz";
  public paginationPageSizeSelector: number[] | boolean = [10, 20, 50, 100];
  public defaultColDef: ColDef = {
    flex: 1,
    initialWidth: 200,
    wrapHeaderText: true,
    wrapText:true,
    autoHeight:true,
    autoHeaderHeight: true,
    headerClass: 'my-dataEdit-class-basic',
    resizable: true,
    sortable: true,
  };
  gridColumnApi:any
  valueColorMap:any = new Map<string, string>(); // Store assigned colors for values
  colorIndex = 0; // Keep track of the current color index
  colorList =["#E74028", "#2CB239", "#25D3EB", "#FFB039", "#1566DE", "#7848FF", "#7AD045", "#CB04DC", "#FA195C", "#9E0000", "#EACD37", "#DD630B", "#BCD03F", "#14BDA9", "#8A05F3", "#D9476A", "#2DADB6", "#E468C2", "#199CD4", "#0934CC",
    "#e74c3c", "#3498db", "#2ecc71", "#f1c40f", "#9b59b6",
    "#1abc9c", "#34495e", "#e67e22", "#16a085", "#d35400",
    "#2980b9", "#8e44ad", "#c0392b", "#27ae60", "#f39c12",
    "#7f8c8d", "#e74c3c", "#3498db", "#2ecc71", "#f1c40f",
    "#9b59b6", "#1abc9c", "#34495e", "#e67e22", "#16a085",
    "#d35400", "#2980b9", "#8e44ad", "#c0392b", "#27ae60",
    "#f39c12", "#7f8c8d", "#e74c3c", "#3498db", "#2ecc71",
    "#f1c40f", "#9b59b6", "#1abc9c", "#34495e", "#e67e22",
    "#16a085", "#d35400", "#2980b9", "#8e44ad", "#c0392b",
    "#27ae60", "#f39c12", "#7f8c8d",
  ]
  error_name:any;
  
  dynamicExcelStyleId: any = [];
  excelStyles: ExcelStyle[] = [];
  backgroudColorDefault:any=[];
  // Grid options for ag-Grid
  gridOptions: any = {
   
    getContextMenuItems: (params:any) => {
      return [
        'copy', // Default copy options
        'copyWithHeaders', // Default copy with headers option
        'copyWithGroupHeaders', // Default copy with group headers option
        'paste', // Default paste option
        {
          name: 'Export to Excel',
          action: () => this.exportXls(true),
        },
      ];
    },
  };
  constructor(
    public filterService: FilterService, 
    private apiService: ApiService,
    private httpClient: HttpClient,
    private routerHandlerService: RouterHandlerService,
    private navigationService: NavigationService,
    private newFilterService: NewFilterService,
    private currency: CurrencyPipe,
    private route: ActivatedRoute,
    private gridStateService: GridStateService,
    private cryptoService: CryptoService,
    private dataService: DataService,
    private dialog: MatDialog,
  ) {
    this.reqSubcription.push(this.filterService.filterQuery.subscribe((q:any)=> {
      this.loader = true;
      this.rowData = [];
      this.loadApiData()
    }))
    this.route.queryParams.subscribe((params: any) => {
      let decryptedParams = this.navigationService.decryptData(params);
      this.clientKey = decryptedParams["cl_key"];
      this.moduleKey = decryptedParams["md_key"];
      this.dashboardKey = decryptedParams["ds_key"];
      this.patientId = decryptedParams["cardId"];
      this.cardId = decryptedParams["cardId"];
    });
  }
  @HostListener("fullscreenchange", ["$event"])
  @HostListener("webkitfullscreenchange", ["$event"])
  @HostListener("mozfullscreenchange", ["$event"])
  @HostListener("MSFullscreenChange", ["$event"])
  screenChange(event:any) {
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }

  closeFullscreen() {
    this.isFullscreen = false;
    this.isActive = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.filterService.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.checkAndHideEmptyColumns();

    // User state
    this.restoreGridStateAndLoadData();

    if(this.gridColumnApi) {
      this.autoSizeAll(true);
    }
  }

  async restoreGridStateAndLoadData() {
    const getUserState = await this.gridStateService.loadGridState(this.widgetUniqKey);

    if (getUserState) {
      const state = getUserState;

      this.selectedSearchByKey = state?.search?.search_prm;
      this.serverSideSearchFilterText = state?.filterValue || '';
      this.filterValue = state?.filterValue || '';
      this.filterSearchParams = state.search;

      this.paginationPageSize = state?.pageSize || 10;
      this.gridApi.paginationSetPageSize(this.paginationPageSize);

      if(state?.type == 'client') {
        this.gridApi.onFilterChanged();
      }

      if (state?.sort) {
        this.gridColumnApi.applyColumnState({
          state: [{ colId: state.sort.sort_col, sort: state.sort.sort_order }],
          applyOrder: false,
          suppressServerSideEvent: true
        });
      }
    }

    this.addExcelStyles()
    this.addCustomTextToPagination();
  }

  addExcelStyles() {
    setTimeout(() => {
      this.dynamicExcelStyleId.forEach((res:any) => {
        let style: ExcelStyle = {
          id: res.encryptColor,
          interior: {
            color: res.colr,
            pattern: 'Solid'
          }
        };
        this.excelStyles.push(style);
      })
    }, 1000)
  }

  addCustomTextToPagination() {
    setTimeout(() => {
      const paginationPanel = document.querySelector('.ag-paging-panel');
      if (!paginationPanel) return;

      // Remove any existing custom text to avoid duplicates
      const oldText = paginationPanel.querySelector('.custom-pagination-text');
      if (oldText) {
        paginationPanel.removeChild(oldText);
      }

      const span = document.createElement('span');
      span.className = 'custom-pagination-text';
      span.style.marginLeft = '10px';
      span.style.fontWeight = '500';
      span.style.color = '#1363df';

      const rowCount = this.rowData.length;
      const currentPage = this.gridApi.paginationGetCurrentPage() + 1;
      const totalPages = this.gridApi.paginationGetTotalPages();

      // Guard: if row count is 0, show a simpler message
      if (rowCount === 0) {
        span.innerText = 'No rows to show';
      } else {
        span.innerText = `Showing page ${currentPage} of ${totalPages}, total ${rowCount} rows`;
      }

      paginationPanel.appendChild(span);
    }, 0);
  }

  onPageSizeChanged(res: any) {
    this.paginationPageSize = res;
    this.gridApi.paginationSetPageSize(res);
    this.gridStateService.saveGridStates({ id: this.widgetUniqKey, config: { pageSize: this.paginationPageSize }})
  }

  hideEmptyColumns() {
    const data: any[] = this.rowData;

    this.columnConfig.forEach((col: any) => {
      const field = col.field!;
      const hasValue = data.some(row => {
        const val = row[field];
        return val !== undefined && val !== null && val !== '';
      });
      // console.log("hasValue", hasValue, field);
      this.gridColumnApi.setColumnVisible(field, hasValue);
    });

  }
  autoSizeAll(skipHeader: boolean) {
    const allColumnIds: string[] = this.gridColumnApi
      .getColumns()!
      .map((column:any) => column.getId());
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  ngOnInit(): void {
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.dataEditGridDiv.nativeElement);
    this.route.params.subscribe((p: any) => {
      this.moduleName = p['module'] || '';
      this.cardName = p['cardName'] || '';

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });
    
    this.loadConfiguration();
    if(this.item?.config?.['no_filter_execution']?.value=='true'){
      this.loadApiData()
    }

  }

 // Quick Filter for Type to Search Filter — contiguous substring match across visible columns
  onQuickFilterChanged(event: any) {
    this.filterValue = event;
    if (this.gridApi) {
      this.gridApi.onFilterChanged();
    }
    // set Search state
    let config = {
      id: this.widgetUniqKey,
      config: {
        dashboardKey: this.dashboardKey,
        filterValue: this.filterValue,
        search: this.filterValue,
        type: 'client'
      }
    }
    this.gridStateService.saveGridStates(config);
  }

  isExternalFilterPresent = (): boolean => {
    return !!this.filterValue && String(this.filterValue).trim().length > 0;
  };

  doesExternalFilterPass = (node: any): boolean => {
    if (!this.filterValue || !node?.data) return true;
    const search = String(this.filterValue).toLowerCase().trim();
    if (!search) return true;

    const cols = this.gridColumnApi?.getAllDisplayedColumns?.() || [];
    const rowText = cols
      .map((col: any) => {
        const field = col.getColDef?.()?.field;
        if (!field) return '';
        const v = node.data[field];
        return v == null ? '' : String(v);
      })
      .join(' ')
      .toLowerCase();

    return rowText.includes(search);
  };
  
  loadConfiguration() {
    this.columnDefs = []
    let cfg = this.item.config;
    this.widgetUniqKey = this.item?.widget_uniq_key || 'widget_'+ this.dashboardKey;
    this.paginationPageSize = cfg["default_pagenation"] || 10;
    // if(cfg?.selected_column)return
    // console.log(cfg.selected_column)

    let headerConfiguration = this.item.config?.widget_header_config || [];
    let paginationFlag = headerConfiguration.find((f:any)=> f.add_header && f.value == 'page_size');
    this.paginationFlag = paginationFlag ? true : false;
     
    cfg?.selected_column?.forEach((res: any) => {
      res.property_CB.forEach((cb: any) => {
        if (cb.name == "Add Column") {
          if (cb.value) {
            var coldef: any = {
              headerName: res.api_resp_column_display_nm,
              field: res.api_resp_column_nm,
              // cellClass: 'cell-wrap-text-basic-grid',
              autoHeight: true,
              menuTabs: ["columnsMenuTab", "filterMenuTab"],
              minWidth: 150,
              refData: res
            };
            if(res.itHasMinWidth) {
              coldef.minWidth = res.colMinWidth || 150;
            }
 
            if (res.api_resp_column_nm == "du_patient_id_new") {
              coldef.minWidth = 150;
            }
            if (res.api_resp_column_nm == "file_name") {
              coldef.minWidth = 300;
            }
            if (res.isAlignment && res.isTextColorCondition) {
              coldef["cellStyle"] = {
                color: res.isTextColor,
                textAlign: res.isAlignment.toLowerCase(),
                display: 'inline-grid'
              };
            } else if (res.isAlignment && !res.isTextColorCondition) {
              coldef["cellStyle"] = {
                textAlign: res.isAlignment.toLowerCase(),
                display: 'inline-grid'
              };
            } 
            else if (res.isTextColorCondition) {
              coldef["cellStyle"] = { color: res.isTextColor };
            }

            // Data Types and Prefix and suffiz;
            let isPrefix = res.isPrefix || "";
            let isSuffix = res.issuffix || "";

            // 
            if (res.isDataType == "date") {
              
               coldef["valueFormatter"] = (params: any) => params.data[res.api_resp_column_nm] ? isPrefix + "" + moment(params.data[res.api_resp_column_nm]).format("MM/DD/YYYY") + "" + isSuffix : "";
               coldef["valueGetter"] = (params: any) => params.data?.[res.api_resp_column_nm] ? isPrefix + " " + moment(params.data[res.api_resp_column_nm]).format("MM/DD/YYYY") + " " + isSuffix : "";
            } else if (res.isDataType == "integer") {
              if(res.isFormats=='Currency') {
                coldef["valueFormatter"] = (params: any) => params.data[res.api_resp_column_nm] ? this.currency.transform(params.value) + "" + isSuffix : "";
              } else if(res.isFormats=='Percentage') {
                coldef["valueFormatter"] = (params: any) => params.data[res.api_resp_column_nm] ? isPrefix + "" + params.value  + "" + isSuffix : params.value==0 ? isPrefix + "" +"0"+ "" + isSuffix:"";
              } else {
                coldef["valueFormatter"] = (params: any) => params.data[res.api_resp_column_nm] ? isPrefix + "" + this.numbedPipe(params.value) + "" + isSuffix : "";
              }
            } else {
              // String for Init cap and upper and lower
              if (res.isDataType == "string") {
                if (res.isTextCase == "from_db") {
                  coldef["valueFormatter"] = (params: any) => params.value ? isPrefix + "" + params.value + "" + isSuffix : "";
                } else if (res.isTextCase == "init") {
                  coldef["valueFormatter"] = (params: any) => params.value ? isPrefix + "" + params.value.toLowerCase().split(" ").map((s: any) => s.charAt(0).toUpperCase() + s.substring(1)).join(" ") + "" + isSuffix : "";
                } else if (res.isTextCase == "cap") {
                  coldef["valueFormatter"] = (params: any) => params.value ? isPrefix + "" + params.value.toUpperCase() + "" + isSuffix : "";
                } else {
                  coldef["valueFormatter"] = (params: any) => params.value ? isPrefix + "" + params.value.toLowerCase() + "" + isSuffix : "";
                }
              }
            }
            
            // Conditional Formatter
            if (res.conditional_format == true || res.isActionIcon == true) {
              coldef["cellRenderer"] = PatientValueGetterComponent;
              coldef["cellRendererParams"] = (params: any) => {
                let selectedData;
                let selectedStyles;
                let columnClickData;
                if (res.conditional_formatting_value) {
                  let abData = res.conditional_formatting_value.filter(
                    (flr: any) => flr.isSelect == true
                  );
                  selectedData = abData;
                }

                if (res.isActionColumn == true) {
                  if (res.isSelectionTypeColumn == "Column Click") {
                    columnClickData = {
                      api_key: res.isSelectionColumnAPI,
                      params: res.isSelectionColumnParameter,
                    };
                  }
                }

                // icon for Actions
                if (res.isActionIcon == true) {
                  selectedStyles = {
                    icon: res.isActionIconName,
                    color: res.isActionIconColor,
                    position: res.isActionPosition,
                    extraText: {
                      prefix: res.isPrefix,
                      suffix: res.issuffix,
                    },
                  };
                  if (res.isEventsInIcon == true) {
                    let iconsClick = {
                      iconType: res.isSelectionTypeIcon,
                      iconApi: res.isSelectionIconAPI,
                      iconPara: res.isSelectionIconParameter,
                    };
                    Object.assign(selectedStyles, {
                      iconsClickEvent: iconsClick,
                    });
                  }
                }
                return (
                  this.cellRendererValueGetter(
                    selectedData,
                    params.data[res.condition_reference_column],
                    params.value,
                    selectedStyles
                  ) || "" + params.value
                );
              };
            }

            if (res.isConditionalFormat && res.isConditionalTextColor === "backgroundColor") {
                this.backgroudColorDefault.push({ column_nm: coldef.field });
            }

            coldef['cellClass'] = (params: any) => {
              const classes = ['cell-wrap-text-basic-grid'];

              if (res.isConditionalFormat && res.isConditionalTextColor === "backgroundColor") {
                const encColor = params.data._cellColors?.[params.colDef.field]?.enc;
                if (encColor) classes.push(encColor);
              }

              return classes;
            };

            if (res.isConditionalFormat) {
              if (res.isConditionalTextColor === "backgroundColor") {
                coldef['cellStyle'] = (params: any) => {
                  return {
                    backgroundColor: params.data._cellColors?.[params.colDef.field]?.rgba || '#fff',
                    color: '#000'
                  };
                };
              } else {
                coldef['cellStyle'] = (param: any) => ({
                  color: this.getDataColor(res.conditionalFormat, param)
                });
              }
            }

            this.columnDefs.push(coldef);
          }
        }
      });
    });
    // console.log("columnDefs",this.columnDefs);
    
  }
  
  rgbaToHex(rgba: string, bgColor: string = '#FFFFFF'): string {
    if(rgba == 'transparent') return '#ffffff'; // Default to white if transparent
    
    // Match rgb(...) or rgba(...) with optional alpha
    const rgbaMatch = rgba.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\s*\)/i);
    if (!rgbaMatch) {
      throw new Error(`Invalid RGBA format: ${rgba}`);
    }

    let [, r, g, b, a] = rgbaMatch;
    const alpha = a !== undefined ? parseFloat(a) : 1; // default alpha = 1

    // Parse background color
    const bg = bgColor.replace('#', '');
    const bgR = parseInt(bg.substring(0, 2), 16);
    const bgG = parseInt(bg.substring(2, 4), 16);
    const bgB = parseInt(bg.substring(4, 6), 16);

    // Blend foreground and background
    const blend = (fg: number, bg: number) =>
      Math.round(fg * alpha + bg * (1 - alpha));

    const finalR = blend(parseInt(r, 10), bgR);
    const finalG = blend(parseInt(g, 10), bgG);
    const finalB = blend(parseInt(b, 10), bgB);

    // Convert to hex string
    const toHex = (n: number) => n.toString(16).padStart(2, '0').toUpperCase();
    return `#${toHex(finalR)}${toHex(finalG)}${toHex(finalB)}`;
  }

  onCellClicked(event: any) {
    // 
    if(event?.colDef?.refData?.isLinkCol) {

      sessionStorage.removeItem('serverSidegridState')
      // Storing for Patient Card if there!
      let resData = {
        patient_case_status: event.data.case_status,
        patient_reason_status: event.data.status_reason,
        patient_id: event.data.patient_id,
      };
      this.newFilterService.setPatientStatusData(resData);
      this.newFilterService.setPatientStatusBaseQuery(this.filterService.baseQuery);

      // Set Navigation
      let conf0 = event?.colDef?.refData
      let nav = {
        dbJSON : conf0.dbJSON,
        s3JSON : conf0.s3JSON,
        pageName : conf0?.s3JSON?.page_nm,
        isDashboardLevel : conf0.isDashboardLevel,
      }

      // Prescriber Name Header
      if(nav.pageName?.toString().replace(/\s+/g, '').toLowerCase() == 'prescribercard') {
        // Prescriber Name
        let prName = 'prescriber_nm'
        if(event.data[prName]) {
          sessionStorage.setItem("navbar_prName", event.data[prName]);
        }
      } 

      sessionStorage.setItem("navHeaderData", JSON.stringify(event.data));
      this.routerHandlerService.navDetailInfo(nav); 
      this.routerHandlerService.storingPayloadAndFilterForGrid(conf0, event.data, this.cardName);

      let query:any = Object.assign({}, this.decryptedParams, {cardId : event.data[conf0.selectNavigatePart]}, {tab_id: 0}, {page: 'list'});
      let queryMaped = this.navigationService.movePropertyToFirst(query, 'tab_id');
      this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${nav.pageName}`, queryMaped);
    }
  }

  loadApiData() {
    const cfg = this.item.config;
    const api = cfg['list_of_api'].api_key;

    let endPoint = this.item.config?.["list_of_api_endpoint"] || '';
    
    // Decide patient ID
    const patientId = this.filterValue? this.filterValue : this.cardId;
    let baseQuery = this.newFilterService.getPatientStatusBaseQuery() || {};
    baseQuery['module_key'] = this.apiService.getModuleKey();
    
    let obj: any = {
      ...baseQuery,
      ...this.filterService.baseQuery,
      report_typ: 'D',
      api_key: api,
      patient_id: patientId
    };

    let columnObj: any = {
      ...baseQuery,
      ...this.filterService.baseQuery,
      report_typ: 'D',
      api_key: cfg?.['list_of_column_api']?.api_key,
      patient_id: patientId
    };

    // if(cfg?.['dynamic_column']?.value == 'true') {
    //       this.httpClient.post(`${this.apiService.apiBaseUrl}/kpi/patient-mastering-columns`, columnObj).subscribe((res: any) => {
    //         this.DynamicColumn = (res.length > 0) ? res : [];
    //         this.AddDynamicColumns();
    //       }, (err: any) => {
    //         this.DynamicColumn = [];
    //       });
    // } else {
      if (cfg?.['dynamic_header']?.value == 'true') {
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${this.apiService.executionUrl}`, columnObj).subscribe((res: any) => {
            let dynamicColumn = (res.length > 0) ? res : [];
            let newColumns:any = []
            dynamicColumn.forEach((res: any) => {
              const coldef: any = {
                headerName: res.header_name,
                field: res.column_nm,
                cellClass: 'cell-wrap-text-basic-grid',
                autoHeight: true,
                menuTabs: ["columnsMenuTab", "filterMenuTab"],
                minWidth: res?.min_width || 150,
                cellStyle: this.item.config?.['list_of_api']?.api_key == 100724
                  ? (params: any) => ({
                      backgroundColor: this.getDistinctValueColor(params.value, 0.3),
                      color: "#000",
                      textAlign: res.alignment || 'left',
                      display: 'inline-grid'
                    })
                  : { textAlign: 'left', display: 'inline-grid' },
                valueFormatter: (params: any) => {
                  return res.data_type == 'date' ? moment(params.value).format("MM/DD/YYYY") :
                  res.data_type == 'integer' ? this.numbedPipe(params.value) : params.value;
                }, 
                refData: res
              };
              newColumns.push(coldef);
            });

            this.columnConfig = [...newColumns];
            this.defaultColumnDefs = this.columnConfig;
            this.columnDefs = [...this.columnConfig];
            
          }, (err: any) => {
            this.DynamicColumn = [];
          });
      } else {
        this.columnConfig = this.columnDefs;
      }
    // }

    this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, obj).subscribe((res: any) => {
      if(res.length>0) {
        this.rowData = [...res];
        // this.autoSizeAll(false);
        this.checkAndHideEmptyColumns();
        this.loadDynamicColumnData(columnObj)
      } else {
        this.loader = false;
      }
      this.checkAndHideEmptyColumns();
      this.error_name = '';
    }, (err: any) => {
      console.log('Data load failed:', err);
      this.rowData = [];
      this.loadDynamicColumnData(columnObj)
      this.loader = false;
      this.error_name = friendlyApiErrorMessage(err);
    });
  }

  loadDynamicColumnData(columnObj:any) {
    const cfg = this.item.config;
    if (cfg?.['dynamic_column']?.value == 'true') {
      this.httpClient.post(`${this.apiService.apiBaseUrl}/kpi/patient-mastering-columns`, columnObj).subscribe((res: any) => {
          this.DynamicColumn = (res.length > 0) ? res : [];

          const allCols = [
            ...this.DynamicColumn,
            ...this.backgroudColorDefault
          ];

          // Precompute colors for all rows + columns
          this.rowData.forEach((row: any) => {
            row._cellColors = row._cellColors || {};

            allCols.forEach((col: any) => {
              if (!row._cellColors[col.column_nm]) {
                const colr = this.getDistinctValueColor(row[col.column_nm], 0.3);

                if (colr && colr.toLowerCase() !== 'transparent') {
                  const hex = this.rgbaToHex(colr);
                  const enc = this.cryptoService.encrypt(colr);

                  row._cellColors[col.column_nm] = { rgba: colr, hex, enc };

                  this.dynamicExcelStyleId.push({
                    encryptColor: enc,
                    colr: hex
                  });
                }
              }
            });
          });
          
          this.AddDynamicColumns();
          this.getPreferences();
          this.loader = false;
        }, (err: any) => {
          this.DynamicColumn = [];
          this.loader = false;
        });
    } else {
      this.columnConfig = this.columnDefs;
      this.getPreferences();
      this.loader = false;
    }
  }

  checkAndHideEmptyColumns() {
    if (this.gridApi && this.gridColumnApi && this.rowData?.length && this.columnConfig?.length) {
      this.hideEmptyColumns();
    }
  }

  AddDynamicColumns() {
    // debugger
    let newColumns: any[] = [];
    const cfg = this.item.config;

    if (this.columnDefs.length > 0 && this.DynamicColumn?.length > 0) {
      this.DynamicColumn = this.DynamicColumn.filter((d: any) => d?.['hide_flg'] === "Y");

      this.DynamicColumn.forEach((res: any) => {
        let coldef: any = {
          headerName: res.display_nm,
          field: res.column_nm,
          autoHeight: true,
          menuTabs: ["columnsMenuTab", "filterMenuTab"],
          minWidth: 220,
          valueFormatter: (params: any) => params.value,
          refData: res
        };

        coldef['cellClass'] = (params: any) => {
          const classes = ['cell-wrap-text-basic-grid'];
          const encColor = params.data._cellColors?.[params.colDef.field]?.enc;
          if (encColor) classes.push(encColor);
          return classes;
        };

        if (this.item.config?.['list_of_api']?.api_key == 100724) {
          coldef['cellStyle'] = (params: any) => {
            return {
              backgroundColor: params.data._cellColors?.[params.colDef.field]?.rgba || '#fff',
              color: '#000'
            };
          };
        } else {
          coldef['cellStyle'] = () => ({
            textAlign: 'left',
            display: 'inline-grid'
          });
        }

        newColumns.push(coldef);
      });

      const index = this.columnDefs.findIndex((obj: any) =>
        Object.values(obj).includes(cfg?.['dynamic_column_start']?.['api_resp_column_nm'])
      );

      this.columnConfig = [
        ...this.columnDefs.slice(0, index + 1),
        ...newColumns,
        ...this.columnDefs.slice(index + 1)
      ];
    } else {
      this.columnConfig = this.columnDefs;
      // console.log("Dynamic column not available");
    }
    this.defaultColumnDefs = this.columnConfig;

    // Update the grid with new column config
    if (this.gridApi && this.columnConfig?.length) {
      this.gridApi.setColumnDefs(this.columnConfig);
    }

    this.addExcelStyles();
    this.checkAndHideEmptyColumns();
  }

  exportXls(event:any) {
    if(event) {
      this.gridApi.exportDataAsExcel({
        fileName: this.item.config['report_heading'] || 'List Data', // Set your desired file name here
        sheetName: this.filterService.selectedBrandName||this.filterService.baseQuery.brand_key  || this.item.config['report_heading']
      });
    }
  }
  // Mat Icon Dynamically set with cell Renderer Value Getter
  cellRendererValueGetter(
    rangeValue: any,
    param: any,
    value: any,
    selectedStyles: any
  ) {

    if (!selectedStyles) {
      if (!rangeValue) return null;
    }
    if (rangeValue && !selectedStyles) {
      for (let idx in rangeValue) {
        let r = rangeValue[idx];
        if (r.col_value == param) {
          let icon: any = r.icon;
          let color: any = r.color;
          return { icon, value, color, selectedStyles };
        }
      }
    } else if (rangeValue && selectedStyles) {
      let fnd: any = rangeValue.find((res: any) => res.col_value == param)
      if (fnd) {
        for (let idx in rangeValue) {
          let r = rangeValue[idx];
          let icon = '';
          let color = '';

          if (r.col_value.toLowerCase() == param.toLowerCase()) {
            icon = r.icon;
            color = r.color;
            return { icon, value, color, selectedStyles };
          }
        }
      } else {
        return { selectedStyles };
      }
    } else if (selectedStyles) {
      return { value, selectedStyles };
    }
  }
  screenChanges(event:any) {
    this.isActive = event
    this.isFullscreen = event
  }
 
  //  ["#F29F93", "#95D89C", "#92E9F5", "#FFD79C", "#8AB2EE", "#BBA4FF", "#BCE8A2", "#E581ED", "#FC8CAD", "#CF8080", "#F4E69B", "#EEB185", "#DDE89F", "#89DED4", "#C582F9", "#ECA3B5", "#96D6DA", "#F1B3E0", "#8CCDE9", "#8399E5",'#7181b4','#82a4e1','#8a9dd5','#9db5f4','#9f8dc8','#a47fa7','#a8d2c7','#b5d3d6','#c3e69b','#cda6e1','#cda4e3','#d7f4f8','#dcb9f1','#dcc9e3','#aadcbf','#e08685','#ec9a97','#ecd2ad','#f1f0c5','#f3c7af','#f4c9f0','#f8d4be','#f8c7e3','#fdd6d7','#fddbcb','#f7e2d8','#ffadab','#ffd3aa',...this.lightColor()]
    getRandomColor(count: any) {
      let shades: any = [];
      for (let i = 0; i < count; i++) {
        var length = 6;
        var chars = '0123456789ABCDEF';
        var hex = '#';
        while (length--) hex += chars[(Math.random() * 16) | 0];
        const shade = hex;
        shades.push(shade);
      }
      return shades;
    }
    lightColor() {
      let extracolor:any=this.getRandomColor(500)
      let lightColor:any=[]
      extracolor.forEach((darkColor:any)=>{
      const val = this.lightenHexColor(darkColor, 60);
      lightColor.push(val)
      })
    return lightColor
    }  
    lightenHexColor(hexColor:any, percent:any) {
      // Parse the hex color to RGB values
      const rgbColor = this.hexToRgb(hexColor);

      // Calculate the lightened RGB values
      const lightenedColor = rgbColor.map((value:any) => Math.min(Math.round(value + value * percent / 100), 255));

      // Convert the lightened RGB values back to hex
      const lightenedHexColor = this.rgbToHex(lightenedColor[0], lightenedColor[1], lightenedColor[2]);

      return lightenedHexColor;
    }
    hexToRgb(hex:any){
      // Remove the hash if it exists
      hex = hex.replace(/^#/, '');

      // Parse the hex color to RGB values
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;

      return [r, g, b];
    }
    rgbToHex(r:any, g:any, b:any) {
      const toHex = (value:any)=>{
        const hex = value.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };

      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }
    
    getDistinctValueColor(value: string, opacity = 0.1): string {
      if(!value){return'transparent'}
      if (!this.valueColorMap.has(value)) {
        const hexColor = this.colorList[this.colorIndex % this.colorList.length]; // Pick color
        this.valueColorMap.set(value, this.hexToRGBA(hexColor, opacity)); // Convert to RGBA with opacity
        this.colorIndex++;
      }
      return this.valueColorMap.get(value) as string;
    }
    hexToRGBA(hex: string, opacity: number): string {
      // Remove '#' if present
      hex = hex.replace(/^#/, '');
    
      // Convert to RGB
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);
    
      return `rgba(${r}, ${g}, ${b}, ${opacity})`; // Apply opacity
    }
    getDataColor(rangeValue: any, param: any) {
      if (!rangeValue) return null;
  
      for (let idx in rangeValue) {
        let r = rangeValue[idx];
        
        // >3000
        if(r.from_value == '>') {
          return r.color
        }
        
        // 0 - 10
        if ((parseInt(r.from_value) <= param.value || parseInt(r.from_value) <= param.value.value) && (param.value.value <= parseInt(r.to_value) || param.value <= parseInt(r.to_value))) {
          return r.color;
        }
      }
      return null;
    }
  
    numbedPipe(value: any) {
      return this.currency.transform(value, "", "", "1.0-2");
      //  return   this.numberpipe.transform(value)
    }
    
  serverSideSearchEmits(event: any) {
    this.filterValue = event?.filterValue;
    this.filterSearchParams = this.filterValue ? (event?.obj || '') : '';

    // Set search state
    let config = {
      id: this.widgetUniqKey,
      config: {
        dashboardKey: this.dashboardKey,
        filterValue: this.filterValue,
        search: this.filterSearchParams,
        type: 'server'
      }
    }

    this.gridStateService.saveGridStates(config);

    // Set this flag

    this.onBtShowLoading();
    this.loadApiData();
  }

  onBtShowLoading() {
    this.loader = true
  }

  preferenceEmitter() {
    let userProvidedColDef: any;
  
    if (this.gridColumnApi?.columnModel?.displayedColumns?.length) {
      userProvidedColDef = this.gridColumnApi.columnModel.displayedColumns.map(
        (m: any) => m.userProvidedColDef
      );
    } else {
      userProvidedColDef = [];
    }
  
    const dialogRef = this.dialog.open(PreferencesComponent, {
      width: '80%',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'du-preferences-dialog',
      data: {
        defaultColumns: this.defaultColumnDefs,
        displayColumn: userProvidedColDef.length === 0 ? this.columnDefs : userProvidedColDef,
        item: this.item,
        page_name: this.item.config["report_heading"],
        dashboardKey: this.dashboardKey,
        module_key: this.apiService.getModuleKey(),
        widgetUniqKey: this.widgetUniqKey,
        employeeKey: this.filterService.baseQuery?.employee_key || 0,
        pageKey: this.pageKey,
      },
      disableClose: true
    });
  
    dialogRef.afterClosed().subscribe((value) => {;
      this.parsePreference(value)
    });
    }
  
 parsePreference(value:any, applied?:any) {
    if (value && value.length > 0) {
      const selectedColumnNames = value.map((v: any) => v.name);

      //  Build a map for fast lookup of original column definitions
      const colMap = new Map(
        this.defaultColumnDefs.map((col: any) => [
          col.headerName || col.field,
          col
        ])
      );

      // Reorder based on user selection
      const orderedColumnDefs = selectedColumnNames
        .map((name: string) => colMap.get(name))
        .filter((col: any) => !!col); // remove undefined just in case

      //  Set new column definitions in the selected order
      this.columnConfig = orderedColumnDefs;
      // this.gridApi.setColumnDefs(this.columnDefs);
    }
  }

    setPreferencesColumn() {
      let data = this.columnConfig;
      if(data?.length>0) {
        let column = '';
        data.forEach((f: any, index: number) => {
          column += `${f.field} '${f.headerName}'${index < data.length - 1 ? ',' : ''}`;
        });
        return column
      }
      return ''
    }
  getPreferences() {
    let obj = {
      dashboard_key: this.dashboardKey,
      page_name: this.item.config?.["page_name"] || '',
      page_key: this.pageKey,
      widget_uinique_key: this.widgetUniqKey
    }
    this.dataService.getPreference(obj).subscribe((res:any) => {
      if(res && res.length) {
        let value = res?.[0]?.preference_value ? JSON.parse(res?.[0]?.preference_value) : '';       
        this.parsePreference(value)
      }
    })
  }
  
  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

}
